<template>
  <div>
    <ValueComparison
      :value="selectReportValue(widgetId)"
      :comparison="selectComparisonNumber(widgetId)"
      v-if="!loading"
    />
    <ValueComparisonLoader v-else />
    <AreaGraph
      :dataSet="selectTrendData('averageRating')"
      :valueType="'float'"
      v-if="!!selectTrendData('averageRating')"
      :granularity="selectGranularity"
    />
  </div>
</template>

<script>
import ValueComparison from '@/components/Modules/Dashboard/Widget/ReportTypes/ValueComparison'
import ValueComparisonLoader from '@/components/Modules/Dashboard/Widget/SkeletonLoaders/ValueComparisonLoader'
import AreaGraph from '@/components/Modules/Dashboard/Widget/ReportTypes/AreaGraph'
import { createNamespacedHelpers } from 'vuex'

const DashboardModule = createNamespacedHelpers('dashboard')

export default {
  name: 'SurveyAverageRating',
  props: ['widgetId'],
  components: {
    ValueComparison,
    ValueComparisonLoader,
    AreaGraph
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...DashboardModule.mapGetters([
      'selectComparisonNumber',
      'selectReportValue',
      'selectTrendData',
      'selectGranularity'
    ])
  },
  methods: {
    ...DashboardModule.mapActions(['fetchSurveyCompletedCount']),
    ...DashboardModule.mapActions(['fetchSurveyAverageRating'])
  },
  async mounted() {
    await this.fetchSurveyAverageRating({ widgetId: this.widgetId })
    this.loading = false
  }
}
</script>
